import { Crosshair } from "@phosphor-icons/react";
import { BUSINESS } from "@/lib/siteData";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-coal/85 border-t border-steel pt-16 pb-8 overflow-hidden" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-steel">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2 mb-5">
              <Crosshair size={28} weight="bold" className="text-oxblood" />
              <span className="font-display uppercase text-2xl tracking-tight">
                N.P. GunSmith <span className="text-brass">& Sales</span>
              </span>
            </div>
            <p className="max-w-md font-body text-bone/55 leading-relaxed">
              Fort Mohave's neighborhood armory since 1990. Sales, service, custom
              builds, and FFL transfers — handled with straight talk and real care.
            </p>
          </div>
          <div className="md:col-span-3">
            <h4 className="font-mono text-[10px] uppercase tracking-[0.2em] text-bone/40 mb-4">Contact</h4>
            <a href={BUSINESS.phoneHref} className="block font-body text-bone/70 hover:text-brass transition-colors mb-2">{BUSINESS.phone}</a>
            <a href={`https://maps.google.com/?q=${encodeURIComponent(BUSINESS.address)}`} target="_blank" rel="noopener noreferrer" className="block font-body text-bone/70 hover:text-brass transition-colors">{BUSINESS.address}</a>
          </div>
          <div className="md:col-span-3">
            <h4 className="font-mono text-[10px] uppercase tracking-[0.2em] text-bone/40 mb-4">Explore</h4>
            {[["Services", "services"], ["Gallery", "gallery"], ["Reviews", "reviews"], ["Visit", "contact"]].map(([l, id]) => (
              <button
                key={id}
                onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })}
                className="block font-body text-bone/70 hover:text-brass transition-colors mb-2 text-left"
              >
                {l}
              </button>
            ))}
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-bone/35">
            © {year} N.P. GunSmith & Sales. All rights reserved.
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-bone/35">
            Must be 18+ / 21+ · FFL Dealer · Fort Mohave, AZ
          </span>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-5 md:px-10 mt-10 pointer-events-none select-none">
        <div className="font-display uppercase tracking-tighter text-[15vw] leading-[0.8] text-steel/25">
          N.P. GUNS
        </div>
      </div>
    </footer>
  );
}
